import { Component } from "@angular/core";

import { UserProfileComponent } from "./components/user-profile/user-profile.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/shared/shared.module";

@Component({
  selector: "app-account",
  imports: [UserProfileComponent, CommonModule, SharedModule],
  templateUrl: "./account.component.html",
  styleUrl: "./account.component.scss",
})
export class AccountComponent {}
